import { useLayoutEffect } from "react";
import { createPortal } from "react-dom";

import { usePageActions } from "@/providers/hooks/use-page-actions";
import type { PageActionsProps, PageToolbarTimeProps } from "@/types/page-actions.types";

export function PageActionsSlot() {
    const { setSlot } = usePageActions();

    return <div ref={setSlot} className="flex flex-wrap items-center justify-end gap-2 empty:hidden" />;
}

export function PageActions({ children }: PageActionsProps) {
    const { slot, register } = usePageActions();
    const hasContent = children != null && children !== false;

    useLayoutEffect(() => {
        if (!hasContent) {
            return;
        }

        return register();
    }, [hasContent, register]);

    if (!slot || !hasContent) {
        return null;
    }

    return createPortal(<>{children}</>, slot);
}

export function PageToolbarTimeSlot() {
    const { setTimeSlot } = usePageActions();

    return <div ref={setTimeSlot} className="flex flex-wrap items-center gap-2 empty:hidden" />;
}

export function PageToolbarTime({ children }: PageToolbarTimeProps) {
    const { timeSlot, registerTime } = usePageActions();
    const hasContent = children != null && children !== false;

    useLayoutEffect(() => {
        if (!hasContent) {
            return;
        }

        return registerTime();
    }, [hasContent, registerTime]);

    if (!timeSlot || !hasContent) {
        return null;
    }

    return createPortal(<>{children}</>, timeSlot);
}
